import React from 'react';

const NoneBroadcast = () => (
  <div className="empty_broadcast">
    <strong>중계 데이터가 없습니다.</strong>
  </div>
);

export default NoneBroadcast;
